import { render, staticRenderFns } from "./SendList.vue?vue&type=template&id=2ff258de&scoped=true&"
import script from "./SendList.vue?vue&type=script&lang=js&"
export * from "./SendList.vue?vue&type=script&lang=js&"
import style0 from "./SendList.vue?vue&type=style&index=0&id=2ff258de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff258de",
  null
  
)

export default component.exports